import $ from 'jquery';
import {isPhone} from '../useragent';
import Watcher from '../watcher';
import StickyGarage from '../sticky-garage';
import Marquee from '../marquee';
import AutoplayVideo from '../video-autoplay';

const NO_ANIMATIONS = (globalThis as any).NO_ANIMATIONS;

const watcher = new Watcher();

const $intro = $('#intro');
$intro.next().prepend('<div class="menu-helper"><div>');

if(!isPhone) {
    const $menu = $('body > header');
    const menuRed = () => $menu.removeClass('white');
    const menuWhite = () => $menu.addClass('white');
    $intro.find('.content').css('overflow', 'hidden');
    watcher.add({
        element: $intro.next().find('.menu-helper')[0],
        onProgress(element, {upperProgress}, direction) {
            if(upperProgress < 1)
                menuWhite();
            else
                menuRed();
        },
    });
}

new StickyGarage(watcher, $intro[0], $('section.new-scaling-layout')[0], {reverseGarage: true});

{
    const $images = $('section.new-scaling-layout .img-container');

    const SPEED = 1.2;
    const startWidth = 85; //%
    const startHeight = 85; //%
    const widthDiv = 100 - startWidth; // % Breite soll auf 100% wachsen
    const heightDiv = 100 - startHeight; // % Höhe soll auf 100% wachsen

    $images.each((index, ele) => {
        watcher.add({
            element: $(ele).find('figure')[0],
            onProgress: (element, {upperProgress}) => {
                const progress = upperProgress;
                const mask = $(ele).find('.mask')[0];
                const width = startWidth + widthDiv * Math.min(1, progress * SPEED); // %
                const height = startHeight + heightDiv * Math.min(1, progress * SPEED); // %

                mask.style.width = `${width}%`;
                mask.style.height = `${height}%`;
            },
        });
    });
}

$('section.new-scaling-layout .emerge.words, #intro .emerge.words').each((index, ele) => {
    watcher.add({
        element: ele,
        onAppearing(element, direction) {
            const visible = $(element).hasClass('emerge-show');
            if(!visible)
                setTimeout(() => $(element).addClass('emerge-show'));
        },
        onDisappeared(element, direction) {
            if (direction == -1) {
                $(ele).removeClass('emerge-show');
            }
        },
    });
});

// Videos einfügen:
const $teaser = $('#intro .teaser');

$teaser.each((i, ele) => {
    const $video = $(ele).find('video') as JQuery<HTMLVideoElement>;
    if (!$video.length) return;
    new AutoplayVideo($video);
});

const $marqueeEles = $('#intro .effect-marquee');

if (!NO_ANIMATIONS && !isPhone) {
    $marqueeEles.each((i, marquee) => {
        new Marquee(marquee);
        watcher.add({
            element: marquee,
            onAppearing(element, direction) {
                const visible = $(element).hasClass('effect-marquee-show');
                if(!visible)
                    setTimeout(() => $(element).addClass('effect-marquee-show'));
            },
            onDisappeared(element, direction) {
                $(element).removeClass('effect-marquee-show');
            },
        });
    });
}
